import ProfileCard from './profileCard'

export { ProfileCard }
